import styled from 'styled-components';
import { BREAKPOINT_MEDIUM } from 'global-search-shared';
export const StyledSearchInput = styled.input.withConfig({
  displayName: "StyledSearchInput",
  componentId: "sc-17fa5se-0"
})(["display:block !important;flex-grow:1;outline:none;width:100%;height:100%;font:", " !important;text-indent:8px;transform:translateZ(0);background:none !important;will-change:color,padding;color:", ";padding:", " !important;padding-right:", ";transition:", ";@media (max-width:", "px){padding-left:30px !important;}&::placeholder{color:var(--search-icon-fill);}"], ({
  theme
}) => `${theme.typography['body-100'].fontWeight} ${theme.typography['body-100'].fontSize}/${theme.typography['body-100'].lineHeight} ${theme.typography['body-100'].fontFamily}`, ({
  isOpen,
  theme
}) => !isOpen && `${theme.color['border-core-subtle']} !important`, ({
  isOpen,
  theme
}) => isOpen ? `${theme.space['200']} 36px ${theme.space['200']} 42px` : `0 0 0 40px`, ({
  hasValue
}) => hasValue && '36px !important', ({
  isOpen
}) => isOpen ? `color .2s ease,
    padding .2s ease !important;` : '', BREAKPOINT_MEDIUM - 1);